export default __webpack_public_path__ + "static/media/GAMES - 3.a2c339b4.png";